const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

const { getElements } = window.BAO.Utils

class UgcSlider extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.urlSwitcher()
    if (this.dataset.disabled) return

    this.checkUgcLoaded()
  }

  urlSwitcher () {
    this.yotpoInterval = setInterval(() => {
      const slidesEl = this.querySelector(
        `.yotpo-pictures-gallery-images-wrapper`,
      )

      if (slidesEl) {
        getElements('.yotpo-lightbox-products-main a').forEach((anchor) =>
          anchor.removeAttribute('target'),
        )

        getElements(
          '.yotpo-lightbox-products-main .yotpo-lightbox-product-button',
        ).forEach((button) => {
          if (button.getAttribute('onclick')) {
            const buttonLink = button
              .getAttribute('onclick')
              .match(/window.open\('(.+?)'/)
            if (buttonLink[1]) {
              button.setAttribute(
                'onclick',
                `location.href = '${buttonLink[1]}'`,
              )
            }
          }
        })

        clearInterval(this.yotpoInterval)
      }
    }, 500)
  }

  checkUgcLoaded () {
    this.yotpoInterval = setInterval(() => {
      const slidesEl = this.querySelector(
        `.yotpo-pictures-gallery-images-wrapper`,
      )

      if (slidesEl) {
        const slideEls = this.querySelectorAll(`.yotpo-single-image-container`)

        slidesEl.classList.add(`keen-slider`)
        slideEls.forEach((el) => el.classList.add(`keen-slider__slide`))

        clearInterval(this.yotpoInterval)
        this.carousel = this.setupCarousel()
      }
    }, 500)
  }

  setupCarousel () {
    const slidesEl = this.querySelector(
      `.yotpo-pictures-gallery-images-wrapper`,
    )
    this.classList.remove('sec-UGC-hidden')

    return new KeenSlider(
      slidesEl,
      {
        selector: `.yotpo-single-image-container`,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.4,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.8,
              spacing: 2,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4.2,
              spacing: 2,
            },
          },
          '(min-width: 1601px)': {
            slides: {
              perView: 4.7,
              spacing: 2,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('ugc-slider')) {
  customElements.define('ugc-slider', UgcSlider)
}
